import CLPLabel from 'owa-mail-store/lib/store/schema/CLPLabel';

export default function shouldMarkCLPLabelAsChecked(label: CLPLabel, selectedLabel: CLPLabel) {
    if (!label) {
        return false;
    }

    // when selectedLabel exist then mark the parent and selected label as checked
    // if it doesn't and there is a defaultLabel then mark the defaultLabel as checked.
    return selectedLabel && shouldLabelBeMarked(label, selectedLabel);
}

function shouldLabelBeMarked(label: CLPLabel, labelToCompare: CLPLabel) {
    if (label.id == labelToCompare.id) {
        return true;
    }

    if (label.children) {
        for (let i = 0; i < label.children.length; i++) {
            if (label.children[i].id == labelToCompare.id) {
                return true;
            }
        }
    }
    return false;
}
